import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  iframe: {
    border: 0,
    borderRadius: '0.5rem',
    minHeight: '30rem',
    marginTop: '1rem',
    width: '100%',
    height: '95%',
  },
}))

export { useStyles }
